import {useTranslation} from "react-i18next";
import {StatisticsBundleWrapper, statisticsType} from "@ots-frontend/ots-data";
import {useMemo} from "react";
import {ByInsight, ByInsightProps} from "../ByInsight/ByInsight";

export type DeliveriesToNonPrimarySiteByCompanyInsightProps =
  Omit<ByInsightProps, 'statisticsType' | 'data' | 'title'>
  & {
  data?: StatisticsBundleWrapper
}

export const DeliveriesToNonPrimarySiteByCompanyInsight = (props: DeliveriesToNonPrimarySiteByCompanyInsightProps) => {
  const {data, ...rest} = props

  const {t} = useTranslation()

  const title = useMemo(() => {
    return t("common.insight.deliveriestononprimarysite", "Deliveries To Non-Primary Site By Company")
  }, [t])

  return (
    <ByInsight
      {...rest}
      title={title}
      data={data?.truckCompanyStats}
      statisticsType={statisticsType.deliveredToNonPrimarySiteCount}/>
  )
}
